import React from 'react';
import { primitiveColors } from '@/theme/tokens';

const VoteMateLogo: React.FC<{ size?: number; 'aria-hidden'?: boolean }> = ({
  size = 48,
  'aria-hidden': ariaHidden,
}) => (
  <svg
    width={size}
    height={size * 0.886} // Maintain aspect ratio: 163/184 ≈ 0.886
    viewBox="0 0 184 163"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label={ariaHidden ? undefined : 'VoteMate logo'}
    aria-hidden={ariaHidden}
  >
    <path d="M0 55L41.3694 163L82 55H0Z" fill={primitiveColors.blue7} />
    <path
      d="M81 54.5263L117.786 154C125.143 148.842 131.029 140.737 133.971 131.895L184 0H135.443C114.843 0 97.1857 12.5263 89.8285 31.6842L81.7357 54.5263"
      fill={primitiveColors.red4}
    />
    <path
      d="M118 153.426C109.933 159.318 99.6667 163 88.6667 163H41L81.3333 54L118 153.426Z"
      fill={primitiveColors.logoPurple}
    />
  </svg>
);

export default VoteMateLogo;
